import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, MessageCircleIcon, StarIcon } from 'lucide-react';
import { COMPANY, waLink } from '../data/company';
const HERO_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/ad55f85e-1f32-429d-ab30-6bb3680b5353.jpg';
const fade = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      delay: 0.2 + i * 0.15,
      ease: [0.22, 1, 0.36, 1] as const
    }
  })
};
export function Hero() {
  return <section id="beranda" className="relative min-h-screen w-full overflow-hidden" data-id="element-113" data-mp="xbfi73z9p32h">
      <div className="absolute inset-0" data-id="element-114" data-mp="sai3509k0p57">
        <img src={HERO_IMG} alt="Mobil mewah PT Wardah Pratama Transport" className="h-full w-full object-cover" data-id="element-115" data-mp="s9gj46ak8sbc" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/85 to-ink/40" data-id="element-116" data-mp="nekm0rqgverd" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-transparent to-ink/60" data-id="element-117" data-mp="3czfm01cr0b73" />
      </div>

      <div className="relative mx-auto flex min-h-screen max-w-7xl flex-col justify-center px-5 pt-28 pb-16" data-id="element-118" data-mp="384s4img5wh20">
        <motion.div custom={0} variants={fade} initial="hidden" animate="show" className="mb-6 flex items-center gap-2" data-id="element-119" data-mp="3o7lprkf2kuls">
          <span className="inline-flex items-center gap-2 rounded-full gold-border bg-ink/60 px-4 py-1.5 text-xs tracking-[0.2em] uppercase text-gold" data-id="element-120" data-mp="39b4hx3639y3z">
            <StarIcon className="h-3.5 w-3.5 fill-gold" data-id="element-121" data-mp="3ebiqcmblra2j" /> Luxury Car Rental · Garut
          </span>
        </motion.div>

        <motion.h1 custom={1} variants={fade} initial="hidden" animate="show" className="font-display max-w-3xl text-4xl font-bold leading-[1.1] sm:text-5xl md:text-6xl lg:text-7xl" data-id="element-122" data-mp="358rdqj6zq89b">
          Luxury Car Rental
          <span className="block text-gold-gradient shimmer" data-id="element-123" data-mp="2vj7wfhyxemgk">in Garut</span>
        </motion.h1>

        <motion.p custom={2} variants={fade} initial="hidden" animate="show" className="mt-6 max-w-xl text-base leading-relaxed text-white/70 sm:text-lg" data-id="element-124" data-mp="2hjynn3d1uumm">
          Solusi rental mobil terpercaya untuk berbagai kebutuhan perjalanan Anda — nyaman,
          aman, dan profesional dengan sentuhan premium.
        </motion.p>

        <motion.div custom={3} variants={fade} initial="hidden" animate="show" className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-125" data-mp="id00cg3n7mjd">
          <a href="#armada" className="btn-glow-gold inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-semibold" data-id="element-126" data-mp="1azuhp455y5sm">
            <PhoneIcon className="h-4 w-4" data-id="element-127" data-mp="111yagnfcjuzs" /> Sewa Sekarang
          </a>
          <a href={waLink(`Halo ${COMPANY.name}, saya ingin bertanya tentang rental mobil.`)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 rounded-full gold-border bg-ink/40 px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-gold/10 hover:text-gold" data-id="element-128" data-mp="x14npxdn4m8h">
            <MessageCircleIcon className="h-4 w-4" data-id="element-129" data-mp="1x7hwng2h071x" /> Hubungi via WhatsApp
          </a>
        </motion.div>

        <motion.div custom={4} variants={fade} initial="hidden" animate="show" className="mt-14 flex flex-wrap gap-8 border-t border-white/10 pt-8" data-id="element-130" data-mp="269zi3saawvnv">
          {[{
          n: '24 Jam',
          l: 'Siap Melayani'
        }, {
          n: '10+',
          l: 'Pilihan Armada'
        }, {
          n: '100%',
          l: 'Driver Profesional'
        }].map(s => <div key={s.l} data-id="element-131" data-mp="2p0h8vrbkph6l">
              <div className="font-display text-2xl font-bold text-gold-gradient sm:text-3xl" data-id="element-132" data-mp="2p08ufuzsy3ta">{s.n}</div>
              <div className="text-xs uppercase tracking-wider text-white/50" data-id="element-133" data-mp="2tztvcayj8m8n">{s.l}</div>
            </div>)}
        </motion.div>
      </div>
    </section>;
}